const findIndextAllCategories = (arr, titleObj) => {
  const titleToCompare = titleObj._income_heads
    ? titleObj._income_heads.title
    : titleObj.title;

  return arr.findIndex(item => {
    const itemTitle = item._income_heads
      ? item._income_heads.title
      : item.title;
    return itemTitle === titleToCompare;
  });
};

export default findIndextAllCategories;
